import Applications from 'Agent/Policies/components/Applications/Applications';
import CorrespondenceDetails from 'Agent/Policies/components/CorrespondenceDetails';
import CorrespondenceSummaries from 'Agent/Policies/components/CorrespondenceSummaries';
import PendingUnderwritingRequirements from 'Agent/Policies/components/PendingUnderwritingRequirements';
import PoliciesView from 'Agent/Policies/components/PoliciesView';
import PolicyDetails from 'Agent/Policies/components/PolicyDetails';
import PolicyServiceRequest from 'Agent/Policies/components/PolicyServiceRequest';
import PolicyUploadDocument from 'Agent/Policies/components/PolicyUploadDocument';
import PolicyRouteConstants from 'Agent/Policies/PolicyRouteConstants';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React from 'react';
import {useDispatch} from 'react-redux';
import {Route, RouteComponentProps, Switch} from 'react-router';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';
import {clearPolicyFilters} from './ducks/policy';

export type PoliciesRoutesProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

export default ({selectedAgency}: PoliciesRoutesProps) => {
  const dispatch = useDispatch();
  useOnNavigateAway(PolicyRouteConstants.POLICIES, () => dispatch(clearPolicyFilters()));

  return (
    <Route
      path={PolicyRouteConstants.POLICIES}
      render={routeProps => (
        <Switch>
          <Route
            exact
            path={`${routeProps.match.url}/correspondence`}
            // @ts-ignore
            render={() => <CorrespondenceSummaries selectedAgency={selectedAgency} searchCriteria={{}} />}
          />
          <Route
            exact
            path={`${routeProps.match.url}/correspondence/:letterNumber`}
            render={() => <CorrespondenceDetails />}
          />
          <Route
            exact
            path={`${routeProps.match.url}/pendingUnderwritingRequirements`}
            render={() => <PendingUnderwritingRequirements />}
          />
          <Route exact path={`${routeProps.match.url}/serviceRequest`} render={() => <PolicyServiceRequest />} />
          <Route exact path={`${routeProps.match.url}/applications`} render={() => <Applications />} />
          <RoutesUnderneathPolicy selectedAgency={selectedAgency} {...routeProps} />
        </Switch>
      )}
    />
  );
};

const RoutesUnderneathPolicy = ({match, selectedAgency}: PoliciesRoutesProps) => {
  useBreadcrumbs('Policies', match.url);

  return (
    <Switch>
      <Route exact path={`${match.url}`} render={() => <PoliciesView selectedAgency={selectedAgency} />} />
      <Route exact path={`${match.url}/:policyId/policyNumber/:policyNumber`} render={() => <PolicyDetails />} />
      <Route
        exact
        path={`${match.url}/:policyId/policyNumber/:policyNumber/upload`}
        render={() => <PolicyUploadDocument />}
      />
    </Switch>
  );
};
